import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, onSnapshot, query, orderBy, limit, startAfter, deleteDoc, doc, updateDoc } from 'firebase/firestore';

const NewsList = () => {
  const [newsList, setNewsList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [month, setMonth] = useState(new Date().getMonth().toString());
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [selectedCategory, setSelectedCategory] = useState('সব');
  const [menuCategories, setMenuCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);
  const NEWS_PER_PAGE = 100;
  
const handleNext = () => {
  if (currentPage < Math.ceil(filteredNews.length / NEWS_PER_PAGE)) {
    setCurrentPage(prev => prev + 1);
  }
};

const handlePrev = () => {
  // আগের পেজে যাওয়ার সময় নরমাল লজিক, ১ এর নিচে নামবে না
  setCurrentPage(prev => Math.max(prev - 1, 1));
};
useEffect(() => {
    // কুয়েরি সাজানো
    const q = query(
      collection(db, "news"), 
      orderBy("timestamp", "desc"),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNewsList(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      // পরের পেজের জন্য শেষ ডকুমেন্টটি সেভ করে রাখা
      setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    });

    return () => unsubscribe();
  }, []);
  // ডাটাবেস থেকে মেনু ক্যাটাগরি লোড করুন
useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "categories"), (snapshot) => {
    const cats = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .sort((a, b) => Number(a.order || 0) - Number(b.order || 0)); // মেনু ম্যানেজারের মতো সর্টিং

    setMenuCategories(cats); // এখন এখানে পুরো অবজেক্টগুলো আছে
  });
  return () => unsubscribe();
}, []);

  const toggleNewsStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'paused' : 'active';
    await updateDoc(doc(db, "news", id), { status: newStatus });
  };

  // এখানে সংশোধন: allNews এর পরিবর্তে newsList ব্যবহার করা হয়েছে
  const activeNews = newsList.filter(news => news.status === 'active');

  // ১. এখানে ফিল্টার না করে সরাসরি সব নিউজ নিন (যাতে পজ করা নিউজগুলো লিস্টে থাকে)
const filteredNews = newsList
  .filter(news => {
    const date = news.timestamp?.toDate() || new Date();
    const matchSearch = (news.title || "").toLowerCase().includes(searchTerm.toLowerCase());
    const matchMonth = date.getMonth().toString() === month.toString();
    const matchYear = date.getFullYear().toString() === year.toString();
    const matchCategory = selectedCategory === 'সব' || news.category === selectedCategory;
    
    return matchSearch && matchMonth && matchYear && matchCategory;
  })
  .sort((a, b) => {
    // নিশ্চিত করছি যে ফিল্টার করার পরেও লেটেস্ট নিউজ উপরেই থাকবে
    const dateA = a.timestamp?.toDate() || new Date(0);
    const dateB = b.timestamp?.toDate() || new Date(0);
    return dateB - dateA; // ছোট থেকে বড়র বিপরীতে সাজানো
  });
const paginatedNews = filteredNews.slice((currentPage - 1) * NEWS_PER_PAGE, currentPage * NEWS_PER_PAGE);

  const saveEdit = async (id) => {
    await updateDoc(doc(db, "news", id), editData);
    setEditingId(null);
  };

  const deleteNews = async (id) => {
    if (window.confirm("নিশ্চিত ডিলিট করতে চান?")) await deleteDoc(doc(db, "news", id));
  };

const handleEditImageUpload = async (e) => {
  const file = e.target.files[0];
  const formData = new FormData();
  formData.append('image', file);
  const apiKey = '874aba0b22e62f51c225a6c83f3f6da5'; // আপনার API Key
  try {
    const response = await fetch(`https://api.imgbb.com/1/upload?key=${apiKey}`, { method: 'POST', body: formData });
    const data = await response.json();
    setEditData({ ...editData, image: data.data.url });
    alert("ছবি আপলোড সম্পন্ন!");
  } catch (error) { alert("ছবি আপলোডে সমস্যা!"); }
};



  return (
    <div style={{ padding: '20px', background: '#fff', borderRadius: '10px' }}>
     {/* ফিল্টার এবং সার্চ সেকশন */}
<div style={{ 
  display: 'flex', 
  gap: '10px', 
  marginBottom: '20px', 
  padding: '15px', 
  background: '#f9f9f9', 
  borderRadius: '5px', 
  flexWrap: 'wrap', 
  alignItems: 'center' 
}}>
  
  <input type="text" placeholder="শিরোনাম সার্চ..." onChange={(e) => setSearchTerm(e.target.value)} style={{ padding: '8px' }} />
  
  <select value={month} onChange={(e) => setMonth(e.target.value)} style={{ padding: '8px' }}>
    {[...Array(12).keys()].map(m => <option key={m} value={m}>{new Date(0, m).toLocaleString('bn-BD', { month: 'long' })}</option>)}
  </select>

  <select value={year} onChange={(e) => setYear(e.target.value)} style={{ padding: '8px' }}>
    <option value="2026">2026</option>
  </select>

  {/* ডাইনামিক ক্যাটাগরি ফিল্টার */}
<select 
  value={selectedCategory} 
  onChange={(e) => setSelectedCategory(e.target.value)} 
  style={{ padding: '8px' }}
>
  <option value="সব">সব</option>
  {menuCategories.map(cat => (
    // এখানে cat.name ব্যবহার করতে হবে, কারণ cat এখন একটি অবজেক্ট
    <option key={cat.id} value={cat.name}>{cat.name}</option>
  ))}
</select>

  <div style={{ marginLeft: 'auto', fontWeight: 'bold', fontSize: '15px', paddingRight: '10px' }}>
    মোট নিউজ: {filteredNews.length} টি
  </div>
</div>

      <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>প্রকাশিত সংবাদ তালিকা</h3>
 <div className="custom-scrollbar" style={{ width: '100%', overflowX: 'auto' }}>
  <table style={{ 
    width: '100%', 
    minWidth: '1000px', // টেবিলটি যেন ভেঙে না যায়, তাই একটি সর্বনিম্ন প্রস্থ দিয়ে দিলাম
    margin: '0 auto', 
    borderCollapse: 'collapse', 
    textAlign: 'center' 
  }}>
        <thead>
  <tr style={{ background: '#333', color: '#fff' }}>
    <th style={{ padding: '10px' }}>তারিখ</th>
    <th style={{ padding: '10px' }}>শিরোনাম</th>
    <th style={{ padding: '10px' }}>প্রতিবেদক</th>
    <th style={{ padding: '10px' }}>ছবি</th>
    <th style={{ padding: '10px' }}>ক্যাপশন</th>
    <th style={{ padding: '10px' }}>বিষয়বস্তু</th>
    <th style={{ padding: '10px' }}>ক্যাটাগরি</th>
    <th style={{ padding: '10px' }}>অ্যাকশন</th>
  </tr>
</thead>
<tbody>
{paginatedNews.map((news, index) => (
      <tr 
        key={news.id} 
        style={{ 
          borderBottom: '1px solid #ddd',
          backgroundColor: index % 2 === 0 ? '#ffffff' : '#fcfcfc', // স্ট্রাইপ ইফেক্ট
          transition: 'all 0.3s ease' // ট্রানজিশন
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = '#f1f1f1'; // হোভার করলে কালার পরিবর্তন
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fcfcfc';
        }}
      >
      {/* ১. তারিখ ও সময় */}
      <td style={{ padding: '10px' }}>
        {news.timestamp ? new Date(news.timestamp.seconds * 1000).toLocaleDateString('bn-BD') : '---'}
      </td>

      {/* ২. শিরোনাম */}
      <td style={{ padding: '10px' }}>
        {editingId === news.id ? <input value={editData.title} onChange={(e) => setEditData({...editData, title: e.target.value})} /> : news.title}
      </td>

      {/* ৩. প্রতিবেদকের নাম */}
      <td style={{ padding: '10px' }}>
        {editingId === news.id ? <input value={editData.reporterName} onChange={(e) => setEditData({...editData, reporterName: e.target.value})} /> : (news.reporterName || 'নিজস্ব প্রতিবেদক')}
      </td>

      {/* ৪. ছবি */}
      <td style={{ padding: '10px' }}>
        {editingId === news.id ? <input type="file" onChange={handleEditImageUpload} /> : <img src={news.image} style={{ width: '50px', borderRadius: '4px' }} />}
      </td>

      {/* ৫. ক্যাপশন */}
      <td style={{ padding: '10px' }}>
        {editingId === news.id ? <input value={editData.caption} onChange={(e) => setEditData({...editData, caption: e.target.value})} /> : (news.caption || '---')}
      </td>

      {/* ৬. বিষয়বস্তু */}
      <td style={{ padding: '10px' }}>
        {editingId === news.id ? <textarea value={editData.content} onChange={(e) => setEditData({...editData, content: e.target.value})} /> : news.content?.substring(0, 30) + '...'}
      </td>

     {/* ৭. ক্যাটাগরি কলাম */}
<td style={{ padding: '10px' }}>
  {editingId === news.id ? (
    <select 
      value={editData.category} 
      onChange={(e) => setEditData({...editData, category: e.target.value})}
    >
      {menuCategories.map(cat => (
        <option key={cat.id} value={cat.name}>{cat.name}</option>
      ))}
    </select>
  ) : (
    news.category
  )}
</td>

{/* ৮. অ্যাকশন কলাম */}
<td style={{ padding: '10px' }}>
  <div style={{ display: 'flex', gap: '5px' }}>
    {editingId === news.id ? (
      <button 
        onClick={() => saveEdit(news.id)} 
        style={{ background: '#2196f3', color: '#fff', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}
      >
        আপডেট
      </button>
    ) : (
      <>
        <button 
          onClick={() => { setEditingId(news.id); setEditData(news); }}
          style={{ padding: '5px 10px' }}
        >
          এডিট
        </button>
        
        <button 
          onClick={() => deleteNews(news.id)} 
          style={{ color: 'red', padding: '5px 10px' }}
        >
          ডিলিট
        </button>
      </>
    )}
  </div>
</td>
</tr>
))}
</tbody>
      </table>
	  </div>
	  
	 <div style={{ 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center', 
  gap: '15px', 
  marginTop: '30px',
  padding: '20px',
  borderTop: '1px solid #eee'
}}>
  
 <button 
  onClick={handlePrev} 
  disabled={currentPage === 1}
  style={{ 
    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
    opacity: currentPage === 1 ? 0.5 : 1 // প্রিভিয়াস বাটন ডিজেবল হলে হালকা দেখাবে
  }}
>
  « পূর্ববর্তী
</button>

<span style={{ margin: '0 15px' }}>পেজ: {currentPage}</span>

<button 
  onClick={handleNext}
  // যদি নিউজের সংখ্যা লিমিটের কম হয়, তার মানে শেষের পেজে পৌঁছে গেছেন, তখন বাটন ডিজেবল হবে
  disabled={newsList.length < NEWS_PER_PAGE}
  style={{ 
    cursor: newsList.length < NEWS_PER_PAGE ? 'not-allowed' : 'pointer',
    opacity: newsList.length < NEWS_PER_PAGE ? 0.5 : 1 
  }}
>
  পরবর্তী »
</button>

</div>
    </div>
  );
}; 

export default NewsList;